/**
 * @file PPD Individual print purchase modal container.
 */

import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import PurchasePpdIndividualPrintModal from '../../components/purchase/PurchasePpdIndividualPrintModal';
import { AlbumForPpdPurchase } from '../../graphql/queries/albums';

const withAlbumForPpdPurchase = graphql(AlbumForPpdPurchase, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loading,
  }),
});

const mapStateToProps = ({ ppdPurchase }) => ({
  cart: ppdPurchase.cart,
});

export default compose(
  withRouter,
  withAlbumForPpdPurchase,
  connect(mapStateToProps),
)(PurchasePpdIndividualPrintModal);
